import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { useRecoilValue } from 'recoil';

import { GetReportRequest } from 'api';
import { reportRequestState, reportState } from 'store';
import { useFormatLocaleDate, StandardDateFormats } from 'config';

export const useBaseReportCsv = (
  reportMethod: (request: GetReportRequest) => Promise<Blob>
): UseMutationResult<Blob> => {
  const report = useRecoilValue(reportState);
  const request = useRecoilValue(reportRequestState);
  const allItemsRequest = { ...request, pageNumber: 1, pageSize: 10000 };

  const formatLocaleDate = useFormatLocaleDate();

  return useMutation(() => reportMethod(allItemsRequest), {
    onSuccess: (data: Blob) => {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(data);
      link.download = `${report?.header} - ${formatLocaleDate(
        new Date(),
        StandardDateFormats.fileNameSuffix
      )}.csv`;
      link.click();
    },
  });
};
